import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/time_icon.svg';
const TimeSvg = ({ className }) => React.createElement(IconSvg, { className: className });
export default TimeSvg;
